
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Forceurbaniaonrentinnavi() {



    const cardData =
    {
        keyword: 'Force Urbania On Rent in Navi Mumbai',
        heading: 'Skyline Cabs: Force Urbania On Rent in Navi Mumbai',
        headingDescription: '​Skyline Cabs offers comfortable and reliable Force Urbania on Rent in Navi Mumbai services for a premium group travel experience. Whether you are planning a corporate outing, family vacation, or a special event, our well-maintained Force Urbania vans and professional drivers ensure a smooth and enjoyable ride. Enjoy door-to-door pickups from anywhere in Navi Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Force Urbania rental with Skyline Cabs today and travel in style and comfort across Maharashtra and beyond!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Force Urbania on Rent in Navi Mumbai",
      "description": "Skyline Cabs offers Force Urbania on rent in Navi Mumbai, perfect for group travel, family trips, or special occasions with spacious seating and a smooth ride."
    },
    {
      "name": "Urbania Rental Service in Navi Mumbai",
      "description": "Book reliable and affordable Urbania rental services in Navi Mumbai with Skyline Cabs. Ideal for both personal and professional travel needs."
    },
    {
      "name": "Rent Force Urbania for Events",
      "description": "Planning an event? Rent a Force Urbania from Skyline Cabs to accommodate your guests with comfort and style. Great for weddings, parties, and more."
    },
    {
      "name": "Navi Mumbai Urbania on Rent for Travel",
      "description": "Travel comfortably in groups with Urbania rentals from Skyline Cabs in Navi Mumbai. Spacious and well-maintained vehicles ensure a great journey."
    },
    {
      "name": "Force Urbania Rental for Corporate Events",
      "description": "Skyline Cabs offers Force Urbania rentals tailored for corporate events. Impress your clients or team with convenient group transport solutions."
    },
    {
      "name": "Force Urbania Rental in Vashi",
      "description": "Looking for a Force Urbania in Vashi? Skyline Cabs provides local rental services with flexible packages and prompt service."
    }
  ],
  "tableData": [
    ["Force Urbania on Rent in Navi Mumbai", "Urbania Rental Service in Navi Mumbai"],
    ["Rent Force Urbania for Events", "Navi Mumbai Urbania on Rent for Travel"],
    ["Force Urbania Rental for Corporate Events", "Force Urbania Rental in Vashi"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Force Urbania on Rent in Navi Mumbai",
      "WhyChoosedescription": "Rent the all-new Force Urbania in Navi Mumbai for your group travel needs. Spacious, stylish, and designed for long journeys, it’s perfect for tours, events, and corporate travel."
    },
    {
      "WhyChooseheading": "Spacious and Comfortable Interiors",
      "WhyChoosedescription": "With plush seating and ample legroom, the Force Urbania offers premium comfort for up to 17 passengers—ideal for both short trips and long-distance journeys."
    },
    {
      "WhyChooseheading": "Perfect for Family, Group, and Corporate Travel",
      "WhyChoosedescription": "Whether it's a family vacation, a wedding group, or corporate team travel, Urbania caters to all with style, comfort, and reliability."
    },
    {
      "WhyChooseheading": "Modern Amenities and Features",
      "WhyChoosedescription": "Equipped with air conditioning, charging ports, reading lights, and more, Urbania ensures a modern travel experience for every passenger."
    },
    {
      "WhyChooseheading": "Professional Chauffeur Service",
      "WhyChoosedescription": "Our experienced and courteous drivers ensure a safe, punctual, and smooth ride, making your journey comfortable and stress-free."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicle",
      "WhyChoosedescription": "We maintain high hygiene standards with regular cleaning and sanitization, ensuring a safe environment for all passengers."
    },
    {
      "WhyChooseheading": "Flexible Rental Packages",
      "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your travel plans in and around Navi Mumbai."
    },
    {
      "WhyChooseheading": "Easy Booking and 24/7 Support",
      "WhyChoosedescription": "Book your Force Urbania easily through our online platform or by phone. Our support team is available 24/7 to assist you at every step."
    }
  ]
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Force Urbania in Navi Mumbai with Skyline Cabs?',
            answer:
                'Renting a Force Urbania in Navi Mumbai is simple. You can book through our website, mobile app, or by calling our customer support. Just select your pickup location, rental date, duration, and any specific travel requirements.',
        },
        {
            id: 2,
            question: 'What is the seating capacity of the Force Urbania available for rent?',
            answer:
                'The Force Urbania is available in multiple seating configurations, typically offering 13, 17, or 20 comfortable seats, making it ideal for group travel, family trips, and corporate outings.',
        },
        {
            id: 3,
            question: 'Is Force Urbania suitable for long-distance travel from Navi Mumbai?',
            answer:
                'Yes, the Force Urbania is built for comfort and reliability on long journeys. With spacious interiors, ample luggage space, and a smooth ride, it’s perfect for outstation trips from Navi Mumbai.',
        },
        {
            id: 4,
            question: 'Are your rental prices for Force Urbania fixed in Navi Mumbai?',
            answer:
                'Yes, we offer fixed and transparent pricing for Force Urbania rentals. The cost includes vehicle hire, driver charges, fuel, and applicable tolls or taxes. You’ll get the final quote before confirming the booking.',
        },
        {
            id: 5,
            question: 'Can I book the Force Urbania for one-day or multi-day use?',
            answer:
                'Absolutely. You can book Force Urbania for a one-day event, airport transfer, wedding, or for multi-day tours across cities. Just share your itinerary and we’ll tailor the package to your needs.',
        },
        {
            id: 6,
            question: 'Is the Force Urbania air-conditioned and comfortable?',
            answer:
                'Yes, all our Force Urbania vehicles are air-conditioned, clean, and well-maintained to ensure a premium travel experience, even in hot or humid weather.',
        },
        {
            id: 7,
            question: 'Can I use Force Urbania for corporate or wedding transportation?',
            answer:
                'Yes, the Force Urbania is a popular choice for corporate transfers, team outings, destination weddings, and group tours. We can also brand the vehicle or provide decoration on request.',
        },
        {
            id: 8,
            question: 'What payment options are available for Force Urbania rental?',
            answer:
                'We accept UPI, credit/debit cards, net banking, and cash payments. All online transactions are secure and confirmed via email or SMS.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Force Urbania rental booking?',
            answer:
                'Yes, you can cancel or modify your booking by contacting our support team or through the app/website. Our cancellation policy is flexible, especially for genuine changes in plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Force Urbania rental in Navi Mumbai?',
            answer:
                'Skyline Cabs offers top-quality Force Urbania vehicles with professional drivers, competitive pricing, and 24/7 customer support. Whether it’s a short ride or a long trip, we ensure a safe, smooth, and stylish travel experience.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ajay Kulkarni",
            rating: 5,
            review: "We rented the Force Urbania for our office outing from Navi Mumbai to Lonavala. The van was super comfortable, and the driver was very accommodating. Everyone enjoyed the ride!"
        },
        {
            name: "Miss. Ritu Sharma",
            rating: 4,
            review: "Booked a Force Urbania for my cousin’s wedding in Navi Mumbai. The vehicle was clean, spacious, and well-maintained. Great service from Skyline Cabs, though pickup was delayed by 10 minutes. Still very satisfied!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania On Rent in Navi Mumbai",
  "image": "https://skylinecabs.com/assets/images/urbania-on-rent-navi-mumbai.jpg",
  "description": "Hire Force Urbania in Navi Mumbai with Skyline Cabs for comfortable and spacious group travel. Available in 13, 17, and 20 seater variants with AC, pushback seats, and professional drivers — perfect for tours, events, and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7543"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/force-urbania-on-rent-in-navi-mumbai"
  }
};



      
     
      

    return (
        <div>
<Helmet>
  <title>Force Urbania On Rent in Navi Mumbai | 13,17,20 Seater AC Van | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Hire Force Urbania in Navi Mumbai with Skyline Cabs for comfortable and spacious group travel. Available in 13, 17, and 20 seater variants with AC, pushback seats, and professional drivers — perfect for tours, events, and outstation travel." 
  />
  <meta 
    name="keywords" 
    content="Force Urbania On Rent in Navi Mumbai, Urbania Rental Navi Mumbai, 13 Seater Urbania Van Navi Mumbai, 17 Seater Urbania Hire, 20 Seater Urbania Rental, AC Urbania with Driver, Urbania for Group Travel, Urbania for Outstation Navi Mumbai, Skyline Cabs Urbania" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/89.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbaniaonrentinnavi;